import React from 'react';
import { Icon } from './Icon.js';
export const IconBasement = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m14,2H6c-2.206,0-4,1.794-4,4v8c0,2.206,1.794,4,4,4h8c2.206,0,4-1.794,4-4V6c0-2.206-1.794-4-4-4Zm2,4v2h-4v-2h4Zm0,4v2h-7v-2h7Zm-2,6H6v-2h10c0,1.103-.897,2-2,2Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconBasement.js.map